/** Formats minutes since midnight as HH:mm, the value format of `<input type="time">`. */
export const minuteOfDayToTimeString = (minuteOfDay: number): string =>
  `${Math.floor(minuteOfDay / 60)
    .toString()
    .padStart(2, '0')}:${(minuteOfDay % 60).toString().padStart(2, '0')}`;

/** Parses HH:mm into minutes since midnight. */
export const timeStringToMinuteOfDay = (timeString: string): number => {
  const [hour, minute] = timeString.split(':').map(Number);
  return hour * 60 + minute;
};
